import { Select, SelectProps } from '@material-ui/core'
import Menu, { MenuProps } from '@material-ui/core/Menu'
import MenuItem, { MenuItemProps } from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import React from 'react'
export const StyledMenu = withStyles(theme => ({
  paper: {
    border: '1px solid #d3d4d5',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 290px)',
    },
  },
}))((props: MenuProps) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

export const StyledMenuItem = withStyles(theme => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
      minHeight: '28px',
    },
  },
}))((props: any) => <MenuItem {...props} />)
